<template>
    <v-layout row>
        <v-flex xs12 sm12>
            <v-card class="elavation-1 transparent">
                <v-toolbar class="transparent" flat height="37">
                     <v-btn dark icon title="Back to previous page" @click="$router.push('/myteam')">
                        <v-icon>arrow_back</v-icon>
                    </v-btn>
                    <v-spacer></v-spacer>
                    <help-link appId="attendance" pageId="team-attendance" color="white"></help-link>
                    <v-btn dark icon title="Export to excel" @click="downloadToExcel" :loading="loading_xls">
                        <v-icon>cloud_download</v-icon>
                    </v-btn>
                     <v-btn-toggle v-model="toggle_view">
                        <v-btn small @click="viewToday" title="Click to view Daily Attendance">
                            Daily
                        </v-btn>
                        <v-btn small class="primary white--text" title="Weekly View">
                            Weekly
                        </v-btn>
                    </v-btn-toggle> 
                </v-toolbar>
            </v-card>
             <v-alert v-if="error" :value="true" color="error" icon="error" outline>
                {{errorMessage}}
            </v-alert>  
            <v-layout row wrap style="margin-top:5px">        
                <v-flex xs12> 
                    <v-card class="elavation-1"> 
                        <v-toolbar flat height="40px">
                            <div class="wp-30 mb-10">
                                <v-text-field v-model="search" append-icon="search" label="Search employee name" single-line hide-details></v-text-field>
                            </div>
                            <v-spacer></v-spacer>
                            <v-btn icon small title="View previous week"  @click="viewPrevious" style="margin-right:10px;" :disabled="disablePrev">
                                <v-icon>chevron_left</v-icon>
                            </v-btn>
                            <b>{{weekly_duration}}</b>
                            <v-btn icon small title="View next week" @click="viewNext" :disabled="disableNext">
                                <v-icon>chevron_right</v-icon>
                            </v-btn>  
                        </v-toolbar>
                        <v-data-table
                            :headers="tableHeader"
                            :items="users_data_filtered"
                            :loading="loading"
                            :rows-per-page-items="rowsPerPageItems"
                            :pagination.sync="paginationSync"
                        >
                            <v-progress-linear v-slot:progress color="primary" indeterminate></v-progress-linear>
                            <template v-slot:items="props">
                                <tr>
                                    <td>
                                        <v-chip>
                                            <v-avatar>
                                                <v-img ref="avatar" :src="awsS3Helper.getAvatarUrl(props.item.userId)"></v-img>
                                            </v-avatar>
                                            {{props.item.firstName}} {{props.item.lastName}} 
                                        </v-chip>
                                    </td>
                                    <td class="attendance-box" @click="viewDaily(1)" title="Click to view daily attendance">
                                        <div v-html="getAttendanceData(1, props.item.userId)"></div>
                                    </td>
                                    <td class="attendance-box" @click="viewDaily(2)" title="Click to view daily attendance">
                                        <div v-html="getAttendanceData(2, props.item.userId)"></div>
                                    </td>
                                    <td class="attendance-box" @click="viewDaily(3)" title="Click to view daily attendance">
                                        <div v-html="getAttendanceData(3, props.item.userId)"></div>
                                    </td>
                                    <td class="attendance-box" @click="viewDaily(4)" title="Click to view daily attendance">
                                        <div v-html="getAttendanceData(4, props.item.userId)"></div>
                                    </td>
                                    <td class="attendance-box" @click="viewDaily(5)" title="Click to view daily attendance">
                                        <div v-html="getAttendanceData(5, props.item.userId)"></div>
                                    </td>
                                    <td class="attendance-box" @click="viewDaily(6)" title="Click to view daily attendance">
                                        <div v-html="getAttendanceData(6, props.item.userId)"></div>
                                    </td>
                                    <td class="attendance-box" @click="viewDaily(7)" title="Click to view daily attendance">
                                        <div v-html="getAttendanceData(7, props.item.userId)"></div>
                                    </td>
                                </tr>
                            </template>
                        </v-data-table> 
                    </v-card>
                </v-flex>
            </v-layout>
        </v-flex>
    </v-layout> 
</template>
<script>
import commonfn from '@/common/functions'
import teamApi from '@/api/team'
import awsS3Helper from '@/helpers/aws-s3'
import userPrefs from '@/helpers/user-prefs'
import rowsPerPageItems from '@/constants/rows-per-page'

export default {     
    name: 'WorkshiftsPlanDetails',
    metaInfo: {
        title: 'Workshifts Plan Details',
        meta: [
            { charset: 'utf-8' },
            { name: 'description', content: 'Workshifts Plan Details' },
            { name: 'viewport', content: 'width=device-width, initial-scale=1' }
            ]
    },
    components: {
        'help-link': () => import('@/components/Common/HelpLink'),
    },
    data () {
        const routeName = this.$route.name
        const savedSort = userPrefs.getSort(routeName)

        return {
            userPrefs,
            rowsPerPageItems,
            paginationSync: {
                rowsPerPage: userPrefs.getRowsPerPage(routeName),
                sortBy: savedSort.sortBy,
                descending: savedSort.descending,
            },
            error: false,
            errorMessage: '',
            loading: false,
            loading_download: false,
            loading_xls: false,
            toggle_view: 1,
            header_data: [],
            users_data: [],
            attendance_data: [],
            week_coverage: {
                from: '',
                to: ''
            },
            search: null,
            selectedWeekNo: null
        }
    },
    methods: {
        viewToday() {
            this.$router.push(`/myteam/attendance`)
        },
        viewDaily(day) {
            const transDate = this.header_data.filter(x => x.day == day)[0].transDate
            const formatted = this.$moment(transDate).format("YYYY-MM-DD")
            this.$router.push(`/myteam/attendance/${formatted}`)
        },
        async viewPrevious() {
            this.selectedWeekNo--
            this.$router.push(`/myteam/attendance/weekly/${this.selectedWeekNo}`)
            this.getWeeklyAttendance()
        },
        async viewNext() {
            this.selectedWeekNo++
            this.$router.push(`/myteam/attendance/weekly/${this.selectedWeekNo}`)
            this.getWeeklyAttendance()
        },
        getAttendanceData(day, userId) {
            const none = `<span class="red--text">None</span>`
            const transDate = this.header_data.filter(x => x.day == day)[0].transDate
            const details = this.attendance_data
                                .filter(x => x.userId == userId && x.transDate == transDate)
            if (details.length > 0) {
                var clockIn = none
                var clockOut = none
                if (details[0].clockIn) clockIn = this.$moment(details[0].clockIn).format('h:ma')
                if (details[0].clockOut) clockOut = this.$moment(details[0].clockOut).format('h:ma')
                return `${clockIn} - ${clockOut}`
            }
            return null
        },
        async getWeeklyAttendance() {
            try {
                this.loading = true
                const data = {
                    teamId: this.teamId,
                    fiscalYear: this.currentYear,
                    weekNo: this.selectedWeekNo
                }
                const response = await teamApi.getTeamStatusWeekly(data)
                if (response && response.status == 200) {
                    this.header_data = response.data.header
                    this.users_data = response.data.users
                    this.attendance_data = response.data.attendance
                    this.week_coverage.from = this.$moment(this.header_data[0].transDate).format('MMM DD, YYYY'),
                    this.week_coverage.to = this.$moment(this.header_data[this.header_data.length-1].transDate).format('MMM DD, YYYY')
                }
                this.loading = false
            }catch(error){
                this.error = true
                this.errorMessage = error
            }
        },
        async downloadToExcel() {
            try {
                this.loading_xls = true
                const data = {
                    teamId: this.teamId,
                    fiscalYear: this.currentYear,
                    weekNo: this.selectedWeekNo
                }
                const response = await teamApi.getTeamStatusWeeklyExcel(data)
                const fileName = `${this.$store.state.selectedTeamName} Weekly Attendance`
                var blob = new Blob([response.data], { type: 'application/vnd.ms-excel' })
                var link = document.createElement('a')
                link.href = window.URL.createObjectURL(blob)
                link.download = `${fileName} - ${this.weekly_duration}.xlsx`
                link.click()
                this.loading_xls = false
            }catch(error){
                this.error = true
                this.errorMessage = error
            }
        }
    },
    async created() {
        this.commonfn = commonfn
        this.awsS3Helper = awsS3Helper
        
        //update header titles
        this.$root.$emit('setHeaderTitles', {
            display: true,
            headerTitle: '',
            headerPageTitle: `${this.$store.state.selectedTeamName} Attendance`
        })
        this.selectedWeekNo = this.$route.params.weekNo
        this.getWeeklyAttendance()
    },
    watch: {
       'paginationSync.rowsPerPage'(newVal) {
            userPrefs.updateRowsPerPage(this.$route.name, newVal)
        },
        'paginationSync.sortBy'(newVal) {
            userPrefs.updateSort(this.$route.name, newVal, this.paginationSync.descending)
        },
        'paginationSync.descending'(newVal) {
            userPrefs.updateSort(this.$route.name, this.paginationSync.sortBy, newVal)
        }
    },
    computed: {
        tableHeader(){
            var headerData = []
            headerData.push(
                {
                    text: 'Employees', 
                    align:'left', 
                    value:'lastName', 
                    width:'45%', 
                    sortable:true
                },
            )
            this.header_data.forEach(item => {
                headerData.push(
                    {
                        text: this.$moment(item.transDate).format('ddd DD'), 
                        align:'center', 
                        value: '', 
                        width:'', 
                        sortable:false
                    },
                )
            })
            return headerData
        },
        teamId() {
            return this.$store.state.selectedTeamId
        },
        currentYear() {
            return this.$moment().year()
        },
        users_data_filtered() {
            var temp = this.users_data
            //search handler
            if (this.search) {
                temp = temp.filter(item => {
                    return item.firstName.toLowerCase().includes(this.search.toLowerCase()) || 
                            item.lastName.toLowerCase().includes(this.search.toLowerCase())
                })
            }
            return temp
        },
        disablePrev() {
            if (!this.loading) {
                return this.$moment(this.header_data[0].transDate).year() < this.$route.params.fiscalYear
            }
        },
        disableNext() {
            if (!this.loading) {
                return this.$moment(this.header_data[this.header_data.length-1].transDate).year() > this.$route.params.fiscalYear
            }
        },
        weekly_duration() {
            return `${this.week_coverage.from} to ${this.week_coverage.to}`
        }
    }
}
</script>
<style scoped>
.attendance-box {
    cursor: pointer;
    font-size: 12px;
    border: 1px solid lightgray;
}
.attendance-box:hover {
    text-decoration: underline;
}
.attendance-box > div {
    text-align: center;
}
</style>